// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__34zb6","label":"Labeled_label__tvIKr","divider":"Labeled_divider__3I57g"};